export default __webpack_public_path__ + "static/media/alga2_lut.aadeb544.jpg";